import { userPost } from "@/utils/request.js"

const WEEKLY_ACTIVITY_SUB_TYPES = Object.freeze({
  weeklyActivity: 10,
  pharmaWeeklyActivity: 20,
})
const QUERY_PROGRESS_WEEKLY_ACTIVITY_ID_URL =
  "/matrix-search/forum/queryProgressWeeklyActivityId"

function getWeeklyActivitySubType(value) {
  return WEEKLY_ACTIVITY_SUB_TYPES[value] || null
}

async function queryProgressWeeklyActivityId(subType) {
  const response = await userPost(QUERY_PROGRESS_WEEKLY_ACTIVITY_ID_URL, {
    subType,
  })

  if (response?.code !== 200) {
    const error = new Error(response?.message || "Failed to query weekly activity")
    error.responsePayload = response
    throw error
  }

  const forumId = Number(response.result)
  return Number.isInteger(forumId) && forumId > 0 ? forumId : null
}

export {
  WEEKLY_ACTIVITY_SUB_TYPES,
  getWeeklyActivitySubType,
  queryProgressWeeklyActivityId,
}
